import React from 'react'
import {Flex, Text, Box, Divider} from '@salesforce/retail-react-app/app/components/shared/ui'
import HeadingComponentName from '../../components/heading-library'
import {remCalc} from '../../../overrides/app/theme/_utils'
import {HeroBanner} from '../../../overrides/app/components/editorial-components'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'

const HeroBannerPage = () => {
    const desktopLightImageLg = getAssetUrl(
        'static/img/hero-banner/light-theme/image-desktop-lg.png',
    )

    const desktopDarkImageLg = getAssetUrl('static/img/hero-banner/dark-theme/image-desktop-lg.png')

    const getTextBlock = (
        desktopAlignment = 'middle-left',
        tabletMobileAlignment = 'bottom-center',
    ) => {
        return {
            label: 'LOREMIPSUM DOLOR SIT AMET',
            title: 'Lorem ipsum dolor sit amet elit.',
            bodyCopy:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed dos eiusmod tempor.',
            desktopAlignment: desktopAlignment,
            tabletMobileAlignment: tabletMobileAlignment,
        }
    }

    const getMedia = (url, contentType) => {
        return {
            url,
            contentType,
            title: 'title',
        }
    }

    const heroBannerSchema = [
        {
            id: '1',
            category: 'Desktop - Light',
            components: [
                {
                    id: 'desktop-light-1',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={true}
                            textBlock={getTextBlock('middle-left', 'top-center')}
                            media={getMedia(desktopLightImageLg, 'image/png')}
                            textAlign="left"
                            height="big"
                        />
                    ),
                },
                {
                    id: 'desktop-light-2',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('middle-right', 'bottom-center')}
                            media={getMedia('', null)}
                            textAlign="left"
                            height="big"
                        />
                    ),
                },
                {
                    id: 'desktop-light-3',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('middle-center', 'top-center')}
                            media={getMedia('', null)}
                            textAlign="center"
                            height="big"
                        />
                    ),
                },
                {
                    id: 'desktop-light-4',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('top-center', 'bottom-center')}
                            media={getMedia('', null)}
                            textAlign="center"
                            height="big"
                        />
                    ),
                },
                {
                    id: 'desktop-light-5',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('bottom-center', 'top-center')}
                            media={getMedia('', null)}
                            textAlign="center"
                            height="big"
                        />
                    ),
                },
            ],
        },
        {
            id: '2',
            category: 'Desktop - Dark',
            components: [
                {
                    id: 'desktop-dark-1',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={true}
                            textBlock={getTextBlock('middle-left', 'top-center')}
                            media={getMedia(desktopDarkImageLg, 'image/png')}
                            textAlign="left"
                            height="big"
                            variant="black"
                        />
                    ),
                },
                {
                    id: 'desktop-dark-2',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('middle-right', 'bottom-center')}
                            media={getMedia('', null)}
                            textAlign="left"
                            height="big"
                            variant="black"
                        />
                    ),
                },
                {
                    id: 'desktop-dark-3',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('middle-center', 'top-center')}
                            media={getMedia('', null)}
                            textAlign="center"
                            height="big"
                            variant="black"
                        />
                    ),
                },
                {
                    id: 'desktop-dark-4',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('top-center', 'bottom-center')}
                            media={getMedia('', null)}
                            textAlign="center"
                            height="big"
                            variant="black"
                        />
                    ),
                },
                {
                    id: 'desktop-dark-5',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('bottom-center', 'top-center')}
                            media={getMedia('', null)}
                            textAlign="center"
                            height="big"
                            variant="black"
                        />
                    ),
                },
            ],
        },
        {
            id: '3',
            category: 'Desktop - Light - 640 - Height',
            components: [
                {
                    id: 'desktop-light-640h-1',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={true}
                            textBlock={getTextBlock('middle-left')}
                            media={getMedia(desktopLightImageLg, 'image/png')}
                            textAlign="left"
                            height="mid"
                        />
                    ),
                },
                {
                    id: 'desktop-light-640h-2',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('middle-right', 'bottom-center')}
                            media={getMedia('', null)}
                            textAlign="left"
                            height="mid"
                        />
                    ),
                },
                {
                    id: 'desktop-light-640h-3',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('middle-center', 'top-center')}
                            media={getMedia('', null)}
                            textAlign="center"
                            height="mid"
                        />
                    ),
                },
                {
                    id: 'desktop-light-640h-4',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('top-center', 'bottom-center')}
                            media={getMedia('', null)}
                            textAlign="center"
                            height="mid"
                        />
                    ),
                },
                {
                    id: 'desktop-light-640h-5',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('bottom-center', 'top-center')}
                            media={getMedia('', null)}
                            textAlign="center"
                            height="mid"
                        />
                    ),
                },
            ],
        },
        {
            id: '4',
            category: 'Desktop - Dark - 640 - Height',
            components: [
                {
                    id: 'desktop-Dark-640h-1',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={true}
                            textBlock={getTextBlock('middle-left', 'bottom-center')}
                            media={getMedia(desktopDarkImageLg, 'image/png')}
                            textAlign="left"
                            height="mid"
                            variant="black"
                        />
                    ),
                },
                {
                    id: 'desktop-Dark-640h-2',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('middle-right', 'top-center')}
                            media={getMedia('', null)}
                            textAlign="left"
                            height="mid"
                            variant="black"
                        />
                    ),
                },
                {
                    id: 'desktop-Dark-640h-3',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('middle-center', 'bottom-center')}
                            media={getMedia('', null)}
                            textAlign="center"
                            height="mid"
                            variant="black"
                        />
                    ),
                },
                {
                    id: 'desktop-Dark-640h-4',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('top-center', 'top-center')}
                            media={getMedia('', null)}
                            textAlign="center"
                            height="mid"
                            variant="black"
                        />
                    ),
                },
                {
                    id: 'desktop-Dark-640h-5',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('bottom-center', 'bottom-center')}
                            media={getMedia('', null)}
                            textAlign="center"
                            height="mid"
                            variant="black"
                        />
                    ),
                },
            ],
        },
        {
            id: '5',
            category: 'Desktop - Light - 460 - Height',
            components: [
                {
                    id: 'desktop-light-460h-1',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={true}
                            textBlock={getTextBlock('middle-left', 'top-center')}
                            media={getMedia(desktopLightImageLg, 'image/png')}
                            textAlign="left"
                            height="small"
                        />
                    ),
                },
                {
                    id: 'desktop-light-460h-2',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('middle-right', 'bottom-center')}
                            media={getMedia('', null)}
                            textAlign="left"
                            height="small"
                        />
                    ),
                },
                {
                    id: 'desktop-light-460h-3',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('middle-center', 'top-center')}
                            media={getMedia('', null)}
                            textAlign="center"
                            height="small"
                        />
                    ),
                },
                {
                    id: 'desktop-light-460h-4',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('top-center', 'bottom-center')}
                            media={getMedia('', null)}
                            textAlign="center"
                            height="small"
                        />
                    ),
                },
                {
                    id: 'desktop-light-460h-5',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('bottom-center', 'top-center')}
                            media={getMedia('', null)}
                            textAlign="center"
                            height="small"
                        />
                    ),
                },
            ],
        },
        {
            id: '6',
            category: 'Desktop - Dark - 460 - Height',
            components: [
                {
                    id: 'desktop-Dark-460h-1',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={true}
                            textBlock={getTextBlock('middle-left', 'bottom-center')}
                            media={getMedia(desktopDarkImageLg, 'image/png')}
                            textAlign="left"
                            height="small"
                            variant="black"
                        />
                    ),
                },
                {
                    id: 'desktop-Dark-460h-2',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('middle-right', 'top-center')}
                            media={getMedia('', null)}
                            textAlign="left"
                            height="small"
                            variant="black"
                        />
                    ),
                },
                {
                    id: 'desktop-Dark-460h-3',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('middle-center', 'bottom-center')}
                            media={getMedia('', null)}
                            textAlign="center"
                            height="small"
                            variant="black"
                        />
                    ),
                },
                {
                    id: 'desktop-Dark-460h-4',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('top-center', 'top-center')}
                            media={getMedia('', null)}
                            textAlign="center"
                            height="small"
                            variant="black"
                        />
                    ),
                },
                {
                    id: 'desktop-Dark-460h-5',
                    component: (
                        <HeroBanner
                            isMaskHeaderActive={false}
                            textBlock={getTextBlock('bottom-center', 'bottom-center')}
                            media={getMedia('', null)}
                            textAlign="center"
                            height="small"
                            variant="black"
                        />
                    ),
                },
            ],
        },
    ]
    return (
        <Flex flexDir="column" overflow="auto">
            <HeadingComponentName name="Hero Banner" />
            <Flex flexDir="column" pt={remCalc(20)}>
                {heroBannerSchema.map(({id, category, components}) => {
                    return (
                        <Box key={id} id={id}>
                            <Text pb={remCalc(10)}>{category}</Text>
                            <Divider mb={remCalc(20)} />
                            {components.map(({id, component}) => (
                                <Box key={id} id={id}>
                                    {component}
                                    <Box p={remCalc(10)} backgroundColor="background.light" />
                                </Box>
                            ))}
                        </Box>
                    )
                })}
            </Flex>
        </Flex>
    )
}

export default HeroBannerPage
